import boulier from "../img/boulier.svg";
import triangleBas from "../img/triangle-bas.svg";
import visuelCSS from  "../img/visuel-css.png";
import logoBlanc from "../img/logo-blanc.webp";
export default function Start (props){


	return <div id={props.id} className="sim-form min-height" >
    <div  >
      <div id="boulier" className="row align-items-center d-none d-sm-flex desktop-only ">
        <div className="col desktop-only">
          <img src={boulier} alt="Boulier" />
        </div>
        <div className="col desktop-only">
          <span>Les P'tits</span>
          <br />
          <span>Simulateurs</span>
        </div>
      </div>

      <div className="d-sm-none boulier-mobile">
        <img src={boulier} alt="Boulier" />
        <span>Les P'tits Simulateurs</span>
      </div>

      <div className="row d-sm-none">
        <div className="col">
          <img src={triangleBas} alt="Triangle bas" className="float-right" />
        </div>
      </div>
    </div>

    <div id="start-content">
      <div className="row align-items-center pt-sm-5">
        <div className="col d-sm-none pt-4">
          <div className="question-droit text-center">
            <span>Ai-je droit</span>
            <span>à la <span className="color-yellow">Complémentaire</span></span>
            <span><span className="color-yellow">Santé Solidaire</span> ?</span>
          </div>
        </div>
        <div className="accueil-left col-sm pr-sm-4 pt-4 pb-4 pt-sm-0 pb-sm-0 text-center">
          <img src={visuelCSS} alt="Aide Sociale" className="ml-sm-5 mt-sm-4" />
        </div>
        <div className="accueil-right col-sm pr-sm-5 pl-sm-4">
          <div className="question-droit d-none d-sm-block desktop-only">
            <span>Ai-je droit</span>
            <span>à la <span className="color-yellow">Complémentaire</span></span>
            <span><span className="color-yellow">Santé Solidaire</span> ?</span>
          </div>

          <div className="text-center text-sm-left pl-2 pr-2 pl-sm-0 pr-sm-0">
            <span className="mb-1 mt-2 font-size-12rem font-size-11rem-sm">Votre diagnostic en quelques clics&nbsp;!</span>
            <span>Quelques questions et vous saurez si</span>
            <span>vous pouvez bénéficier de cette aide&nbsp;!</span>

            <span className="font-bold mt-2">Informations à prévoir : <u>Ressources des 12 derniers mois</u></span>

            <button id="start-simulation" className="btn btn-primary mt-4" onClick={props.nextStep} >C'est parti</button>
          </div>
        </div>
      </div>
    </div>

    <div className="site-address pt-3 pt-sm-0">
      <div className="col">
        <img src={logoBlanc} alt="logo aide-sociale.fr"/>
      </div>
    </div>
  </div>;
}